import { Box, Heading } from '@hover/blueprint';
import React from 'react';
import { useInterSectionObserver } from '../../hooks';
import { CAREERS_FAQ_ITEMS } from '../../constants';
import { SharedFaq } from '../common';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const FAQ: React.FC<Props> = ({ setCurrentSection }) => {
  const faqRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting) {
        setCurrentSection('FAQ');
      }
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.4,
    },
  );

  return (
    <Box
      maxW="100%"
      flexDir="column"
      alignItems="center"
      py={{ base: 700, desktop: 1000 }}
      ref={faqRef.elementRef}
      mb={{ base: 700, desktop: 0 }}
      position="relative"
      px={{ base: 500, tablet: '56px' }}
    >
      <Box
        id="faq"
        position={{ desktop: 'absolute' }}
        display={{ base: 'none', desktop: 'block' }}
        w={0}
        h={0}
        top="200px"
      />
      <Heading
        as="h2"
        fontWeight={{ base: 600, desktop: 600 }}
        size={{ base: 500, desktop: 700 }}
        marginBottom={{ base: 800, desktop: '88px' }}
      >
        Frequently asked questions
      </Heading>
      <SharedFaq questions={CAREERS_FAQ_ITEMS} />
    </Box>
  );
};

export default FAQ;
